import type { Loading } from "../model/inp/loadings.ts";
import type { Pollutant } from "../model/inp/pollutants.ts";
import { useT } from "../i18n/hooks.ts";
import { CatalogPickerTable } from "./CatalogPickerTable.tsx";

export function LoadingsEditor({
  subcatchmentName,
  pollutants,
  loadings,
  onChange,
}: {
  subcatchmentName: string;
  pollutants: Pollutant[];
  loadings: Loading[];
  onChange: (rows: Loading[]) => void;
}) {
  const t = useT();

  return (
    <CatalogPickerTable
      rows={loadings}
      catalog={pollutants}
      onChange={onChange}
      getCategory={(l) => l.pollutant}
      getValue={(l) => l.initialBuildup}
      withCategory={(l, pollutant) => ({ ...l, pollutant })}
      withValue={(l, initialBuildup) => ({ ...l, initialBuildup })}
      newRow={(pollutant) => ({ subcatchment: subcatchmentName, pollutant, initialBuildup: 0 })}
      title={t("propertyPanel.loadings")}
      categoryHeader={t("projectData.pollutant")}
      valueHeader={t("propertyPanel.initialBuildup")}
      emptyCatalogHint={t("projectData.noPollutantsYet")}
      emptyRowsHint={t("propertyPanel.noLoadings")}
      addLabel={t("propertyPanel.addLoading")}
      deleteLabel={t("propertyPanel.deleteLoading")}
    />
  );
}
